import { Property } from 'csstype';

export type BorderProps = {
  border?: Property.Border;
  borderBlockStart?: Property.BorderBlockStart;
  borderBlockEnd?: Property.BorderBlockEnd;
  borderInlineStart?: Property.BorderInlineStart;
  borderInlineEnd?: Property.BorderInlineEnd;
  borderRadius?: Property.BorderRadius;
};

const borderInterpolations = {
  border: ({ border }: Pick<BorderProps, 'border'>) =>
    border === undefined
      ? {}
      : {
          border
        },
  borderBlockStart: ({ borderBlockStart }: Pick<BorderProps, 'borderBlockStart'>) =>
    borderBlockStart === undefined
      ? {}
      : {
          borderBlockStart
        },
  borderBlockEnd: ({ borderBlockEnd }: Pick<BorderProps, 'borderBlockEnd'>) =>
    borderBlockEnd === undefined
      ? {}
      : {
          borderBlockEnd
        },
  borderInlineStart: ({ borderInlineStart }: Pick<BorderProps, 'borderInlineStart'>) =>
    borderInlineStart === undefined
      ? {}
      : {
          borderInlineStart
        },
  borderInlineEnd: ({ borderInlineEnd }: Pick<BorderProps, 'borderInlineEnd'>) =>
    borderInlineEnd === undefined
      ? {}
      : {
          borderInlineEnd
        },
  borderRadius: ({ borderRadius }: Pick<BorderProps, 'borderRadius'>) =>
    borderRadius === undefined
      ? {}
      : {
          borderRadius
        }
};

export { borderInterpolations };
